export default {
  DatePicker: {
    showClose: "allowClear",
    getCalendarContainer: "getPopupContainer",
    renderIcon: "suffixIcon",
    renderFooter: "renderExtraFooter",
    defaultPanelShown: "defaultOpen"
  },
  TimePicker: {
    showClear: "allowClear",
    onOpen: "onOpenChange",
    onClose: "onOpenChange",
    addon: "renderExtraFooter"
  },
  Select: {
    onKeyDown: "onInputKeyDown",
    data: "options",
    multiple: "mode",
    tags: "mode"
  },
  Modal: {
    show: "visible",
    backdrop: "mask",
    onHide: "onCancel",
    onExited: "afterClose",
    dialogClassName: "wrapClassName",
    backdropStyle: "maskStyle",
    container: "getContainer",
    backdropClosable: "maskClosable"
  },
  Tag: {
    colors: "color",
    deleted: "closable",
    tagClick: "onClick"
  },
  Dropdown: {
    delayShow: "mouseEnterDelay",
    delayHide: "mouseLeaveDelay"
  },
  Collapse: {
    onSelect: "onChange"
  },
  Tabs: {
    onPrevClick: "onTabScroll",
    onNextClick: "onTabScroll",
    extraContent: "tabBarExtraContent",
    tabBarPosition: "tabPosition"
  },
  Tooltips: {
    onMouseOut: "onMouseLeave",
    rootClose: "maskClosable",
    container: "getContainer",
    show: "visible"
  }
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/warningConfig.js